function initReadspeaker() {
  const readSpeakerWrapper = document.querySelector('.readspeaker');
  const readSpeaker = document.getElementById('readspeaker_button1');

  if (readSpeakerWrapper && readSpeaker) {
    const toggleButton = readSpeakerWrapper.querySelector('.readspeaker__toggle');
    const readSpeakerPlayBtn = readSpeaker.querySelector('.rsbtn_play');

    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

      toggleButton.setAttribute('aria-expanded', !isExpanded);
      readSpeakerWrapper.classList.toggle('is-expanded');
    })

    readSpeakerPlayBtn.addEventListener('click', () => {
      readSpeakerWrapper.classList.add( 'is-playing' );

      // Wait for the close button to be added to the DOM for the first time
      setTimeout(() => {
        const readSpeakerCloseBtn = document.querySelector('.rsbtn_closer');

        readSpeakerCloseBtn.addEventListener('click', () => {
          readSpeakerWrapper.classList.remove( 'is-playing' );
        })
      }, 1)
    })
  }

  window.rsConf={
    general: {usePost: true}
  }
}

export default {
  init() {
    initReadspeaker();
  },
};
